import { CloudCheck, CloudSlash, Export, SignIn, UserCircle } from '@phosphor-icons/react';
import type { StudioController } from '../hooks/useStudio';

interface HeaderProps {
  studio: StudioController;
  onLogin: () => void;
  onShare: () => void;
  onCloudSave: () => void;
  readOnly?: boolean;
}

export function Header({ studio, onLogin, onShare, onCloudSave, readOnly = false }: HeaderProps) {
  const { project, patchProject, saveState, user } = studio;
  return (
    <header className="app-header">
      <a className="brand" href="/" aria-label="ExpoSpace 홈">
        <span className="brand-mark" aria-hidden="true"><span /></span>
        <span className="brand-name">ExpoSpace</span>
      </a>
      <div className="project-title-wrap">
        <input
          className="project-title"
          value={project.name}
          onChange={(event) => patchProject({ name: event.target.value })}
          aria-label="프로젝트 이름"
        />
        <span className="save-state" aria-live="polite">
          {saveState === 'saving' ? '로컬 저장 중' : '로컬에 저장됨'}
        </span>
      </div>
      <div className="header-actions">
        {readOnly && <span className="read-only-badge">읽기 전용</span>}
        {!readOnly && <>
        <button className="button button-ghost header-cloud" type="button" onClick={onCloudSave} aria-label="클라우드 저장">
          {user ? <CloudCheck size={17} /> : <CloudSlash size={17} />}
          <span>{user ? '클라우드 저장' : '로컬 전용'}</span>
        </button>
        <button className="button button-secondary" type="button" onClick={onShare} aria-label="공유">
          <Export size={17} />
          <span>공유</span>
        </button>
        </>}
        <button className="account-button" type="button" onClick={onLogin} aria-label={user ? '계정 메뉴' : '로그인'}>
          {user ? <UserCircle size={22} weight="fill" /> : <SignIn size={20} />}
          <span>{user?.name ?? '로그인'}</span>
        </button>
      </div>
    </header>
  );
}
